import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '@/components/Seo';
import { useGroundingSchemas } from '@/lib/useGroundingSchemas';
import { Home, ArrowLeft } from 'lucide-react';

/**
 * Pay-per-Install Grounding Page
 * Optimized for Generative Engine Optimization (GEO)
 */
export default function PayPerInstallPage() {
  const [htmlContent, setHtmlContent] = useState('');
  useGroundingSchemas(htmlContent, {
    headline: 'Was ist Pay-per-Install (PPI)? Definition, Vorteile & Anbieter 2026',
    description: 'Pay-per-Install (PPI) ist ein Abrechnungsmodell im App-Marketing, bei dem Werbetreibende nur für verifizierte App-Downloads zahlen.',
    path: '/was-ist-pay-per-install',
  });

  useEffect(() => {
    // Load the HTML content
    fetch('/grounding-pages/was-ist-pay-per-install.html')
      .then(res => res.text())
      .then(html => {
        // Extract body content (everything between <body> and </body>)
        const bodyMatch = html.match(/<body[^>]*>([\s\S]*)<\/body>/i);
        if (bodyMatch) {
          setHtmlContent(bodyMatch[1]);
        }
      })
      .catch(err => console.error('Error loading grounding page:', err));
  }, []);

  return (
    <>
      <Seo
        title="Was ist Pay-per-Install (PPI)? Definition, Vorteile & Anbieter 2026"
        description="Pay-per-Install (PPI): Werbetreibende zahlen nur für verifizierte App-Downloads. Alles zu Definition, Vorteilen, Kosten und Anbietern im Guide 2026."
        path="/was-ist-pay-per-install"
        ogType="article"
      />

      {/* Navigation Bar */}
      <nav className="sticky top-0 z-50 bg-white border-b border-slate-200 shadow-sm">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Link
                to="/"
                className="flex items-center gap-2 text-slate-600 hover:text-teal-600 transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                <span className="hidden sm:inline">Zurück</span>
              </Link>
            </div>
            <Link to="/" className="flex items-center gap-2">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-teal-400 to-cyan-500 flex items-center justify-center">
                <span className="text-white font-bold text-sm">✦</span>
              </div>
              <span className="font-bold text-lg">
                mar<span className="text-teal-600">KI</span>pilot
              </span>
            </Link>
          </div>
        </div>
      </nav>

      {/* Content from static HTML */}
      <div 
        className="grounding-page-content"
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />

      <style jsx>{`
        .grounding-page-content {
          max-width: 800px;
          margin: 0 auto;
          padding: 40px 24px;
        }
      `}</style>
    </>
  );
}
